import {AxisLeft} from '@visx/axis';
import React, {FC} from 'react';

import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {AxisProps, DEFAULT_TICK_LABEL_PROPS, findTickLabelFillColor} from './commons';

export const YAxis: FC<AxisProps> = ({scale, tickFormat, hideTickValues, numTicks}) => {
  const theme = useUserTheme();

  return (
    <AxisLeft
      scale={scale}
      stroke={theme.greys.shade30}
      hideTicks
      hideAxisLine
      tickLabelProps={() => ({
        ...DEFAULT_TICK_LABEL_PROPS,
        fill: findTickLabelFillColor(theme),
        textAnchor: 'end',
        verticalAnchor: 'middle',
      })}
      tickValues={hideTickValues ? [] : undefined}
      tickFormat={tickFormat}
      numTicks={numTicks || undefined}
    />
  );
};

export const yAxisWidth = 40;
